import axios, { type AxiosInstance, type AxiosRequestConfig } from 'axios';
import { reportToBugsnag } from '@/utilities/bugsnag-helper';
import { attachAccessTokenInterceptor } from '@/auth/token';

interface CreateApiClientOptions {
    enableBugsnag?: boolean;
}

interface ApiRequestConfig extends AxiosRequestConfig {
    useBugSnag?: boolean;
}

export function createApiClient({ enableBugsnag = false }: CreateApiClientOptions = {}): AxiosInstance {
    const api = axios.create({
        baseURL: import.meta.env.VUE_APP_API,
        headers: {
            'Content-Type': 'application/json',
        },
    });

    attachAccessTokenInterceptor(api);

    api.interceptors.response.use(
        response => response,
        error => {
            const requestConfig = (error?.config ?? {}) as ApiRequestConfig;
            const shouldNotify = enableBugsnag || requestConfig.useBugSnag === true;

            if (shouldNotify) {
                reportToBugsnag(error);
            }

            return Promise.reject(error);
        },
    );

    return api;
}
